import React from "react";
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import GamesSection from "../components/GamesSection";
import {
  FeaturesBlock,
  EditorBlock,
  SkinsBlock,
  AppBlock,
  DiamondsBlock,
  AlphaBlock,
  EcosystemBlock,
  MaskaBlock,
  AuthorBlock,
} from "../components/ContentBlocks";
import usePageTitle from "../hooks/usePageTitle";
import "../styles/landing.css";

/**
 * Главная (лендинг). Порядок секций:
 * hero → карточки игр → бесплатно → редактор → скины → приложение →
 * алмазы → альфа-версия → экосистема → Маська → об авторе.
 */
export default function HomePage() {
  usePageTitle();
  return (
    <Layout>
      <Hero />
      <GamesSection />
      <FeaturesBlock />
      <EditorBlock />
      <SkinsBlock />
      <AppBlock />
      <DiamondsBlock />
      <AlphaBlock />
      <EcosystemBlock />
      <MaskaBlock />
      <AuthorBlock />
    </Layout>
  );
}
